import { Grid } from "@material-ui/core";
import { Tooltip, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../../../src/assets/DeleteIcon.svg";
import DialogBox from "../../../components/DialogBoxComponent/DialogBox";
import Toast from "../../../components/ToastContainer/CustomToast";
import { deleteSiteType } from "../../../slices/Site/SiteTypeSlice";
import { ThemeContext } from "../../../theme/ThemeContext";

export default function DeleteSiteType(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const handleSubmit = () => {
    const siteTypeId = props.DeleteSiteTypeId;

    dispatch(deleteSiteType(siteTypeId))
      .unwrap()
      .then((data) => {
        handleClose(false);
        if (data.code === "LMSI6006") {
          props.delete();
          Toast(t(data.message), "success");
          return;
        } else {
          Toast(t(data.message), "error");
        }
      });
  };

  return (
    <>
      <DialogBox
        Header={t("COMMON004")}
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid item>
            <DeleteIcon width="60px" height="50px" />
          </Grid>
          <Grid
            item
            style={{
              opacity: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              fontSize: "17px",
              marginTop: "15px",
              color: darkMode ? "#fff" : "#242424",
            }}
          >
            <Typography
              style={{
                fontSize: "15px",
                whiteSpace: "pre-line",
              }}
            >
              {t("DELETEMSG")}
            </Typography>
            <Tooltip title={props.DeleteSiteTypeName}>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: "15px",
                  margin: "0 5px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  maxWidth: "200px",
                }}
              >
                {props.DeleteSiteTypeName}
              </Typography>
            </Tooltip>
            <Typography
              style={{
                fontSize: "15px",
              }}
            >
              ?
            </Typography>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
